import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { ChallengeNotifStrategy } from "../strategies/challenge-notif-strategy";
import { CommentNotifStrategy } from "../strategies/comment-notif-strategy";
import { Strategy } from "../model/notification.model";
import { RequestNotifStrategy } from "../strategies/request-notif-strategy";
import { LikeNotifStrategy } from "../strategies/like-notif-strategy";
import { FollowNotifStrategy } from "../strategies/follow-notif-strategy";
import { ClubNotifStrategy } from "../strategies/club-notif-strategy";
import { GeneralNotifSterategy } from "../strategies/general-notif-sterategy";



export const NotificationStrategyMap: Partial<Record<ActivityVerbEnum, Strategy>> = {

    // ?This map connects each activity type (verb) to its matching strategy class.
    //? The factory uses it to find which strategy should create the notification text.

    // Comment
    [ActivityVerbEnum.Commented]: CommentNotifStrategy,

    // Like
    [ActivityVerbEnum.Liked]: LikeNotifStrategy,
    [ActivityVerbEnum.Reacted]: LikeNotifStrategy,

    // Club
    [ActivityVerbEnum.ClubJoinRequested]: ClubNotifStrategy,
    [ActivityVerbEnum.CourseEnded]: ClubNotifStrategy,
    [ActivityVerbEnum.Coursed]: ClubNotifStrategy,
    [ActivityVerbEnum.Polled]: ClubNotifStrategy,
    [ActivityVerbEnum.PollClosed]: ClubNotifStrategy,
    [ActivityVerbEnum.Meetinged]: ClubNotifStrategy,
    [ActivityVerbEnum.ClubJoinRequestAccepted]: ClubNotifStrategy,
    [ActivityVerbEnum.ClubInvited]: ClubNotifStrategy,


    // Challenge
    [ActivityVerbEnum.Reminder]: ChallengeNotifStrategy,
    [ActivityVerbEnum.ChallengeFailed]: ChallengeNotifStrategy,
    [ActivityVerbEnum.ChallengeObtained]: ChallengeNotifStrategy,
    [ActivityVerbEnum.AchievementObtained]: ChallengeNotifStrategy,

    // Follow Activities
    [ActivityVerbEnum.Followed]: FollowNotifStrategy,
    [ActivityVerbEnum.FollowRequested]: FollowNotifStrategy,
    [ActivityVerbEnum.Joined]: FollowNotifStrategy,

    // Requests
    [ActivityVerbEnum.bloggerAccept]: RequestNotifStrategy,
    [ActivityVerbEnum.LibrarianAccept]: RequestNotifStrategy,
    [ActivityVerbEnum.BookRequestAccepted]: RequestNotifStrategy,

    // General
    [ActivityVerbEnum.Posted]: GeneralNotifSterategy,

};
